import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import MarketplaceStopSyncViewPage from "../marketplace/pages/MarketplaceStopSyncViewPage.vue";
import MarketplaceStopSyncCreatePage from "../marketplace/pages/MarketplaceStopSyncCreatePage.vue";

export const MarketplaceRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "marketplace"
) => [
  {
    name: "MarketplaceStopSyncViewPage",
    path: `${prefix}/stop-sync`,
    component: MarketplaceStopSyncViewPage,
    meta: { title: "Marketplace Stop Sync List" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.MARKETPLACE_STOP_SYNC
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "MarketplaceStopSyncCreatePage",
    path: `${prefix}/stop-sync/create`,
    component: MarketplaceStopSyncCreatePage,
    meta: { title: "Create New Marketplace Stop Sync" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.MARKETPLACE_STOP_SYNC
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
